<template>
    <div>
        <h2 class="text-24 fw-600">{{ $t("qa.title") }}</h2>
        <p class="text-16 fw-400 mt-15">{{ $t("qa.description") }}</p>
        <div class="mt-10">
            <div class="accordion" id="questionsAccordion">
                <div class="accordion-item" v-for="faqQestion, i in questions" :key="i">
                    <h2 class="accordion-header" :id="'headingTwo' + i">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            :data-bs-target="'#collapseTwo' + i" aria-expanded="false" aria-controls="collapseTwo">
                            {{ faqQestion?.question }}
                        </button>
                    </h2>
                    <div :id="'collapseTwo' + i" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#questionsAccordion">
                        <div class="accordion-body">
                            {{ faqQestion?.answer }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end gap-3 mt-30">
                <button class="main-btn">
                    {{ $t("stillHaveQuestions") }}
                </button>

                <button class="main-button">
                    {{ $t("askAQuestion") }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { getFaq } from '@/Services/api/HelpersServices';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            questions: null,
        }
    },
    methods: {
        async getQuestions() {
            try {
                const response = await getFaq();
                this.questions = response.data;
            } catch (error) {
                console.log(error)
            }
        }
    },
    computed: {
        ...mapGetters(['currentLanguage']),
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                this.getQuestions();
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    }
}
</script>
<style lang="scss" scoped>
h2 {
    color: #09445D;
    line-height: 140%;
}

h2+p {
    color: #666;
}

.accordion-item {
    padding: 18px;
    background: #F9FBFB;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.accordion-body {
    border-top: 1px solid #E6E6E6;
}

.accordion-button::after {
    content: '🔒';
    color: gray;
    font-size: 20px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 8px;
    background: none;
    width: 30px;
    height: 30px;
}

:lang(ar) {
    .accordion-button::after {
        margin-left: 0;
        margin-right: auto;
    }
}

:lang(en) {
    .accordion-button::after {
        margin-right: 0;
        margin-left: auto;
    }
}

.accordion-button:not(.collapsed)::after {
    content: '-';
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
    color: #fff;
    background: var(--main, #206387);
}

.accordion-button:not(.collapsed) {
    background-color: transparent;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.accordion-item {
    margin-bottom: 24px;
    border-radius: 10px;
    background: var(--color-gray-10, #FFF);
    -webkit-box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);
    box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);
    border: none !important
}

.accordion-button:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
}

.accordion-button {
    .btn-title {
        color: #4D4D4D;
        font-size: 16px;
        font-weight: 500;
    }

    .btn-time {
        color: var(--Neutral-500, #999);
        font-size: 16px;
        font-weight: 400;
        margin-top: 9px;

        &:lang(en) {
            text-align: left;
        }

        &:lang(ar) {
            text-align: right;
        }
    }

}

ul li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;

    span {
        color: var(--Neutral-700, #4D4D4D);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
}

input[type="checkbox"] {
    width: 20px;
    height: 20px;
}

.main-btn {
    color: var(--Neutral-500, #999);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
}
</style>